import { Config } from '@measured/puck';

import { RootProps, createRootRenderer } from './render-root';

export const createRootConfig = (): NonNullable<Config<RootProps, RootProps>['root']> => {
  return {
    defaultProps: {
      title:
        'Landing Page: tokens {firstName}, [some text to link](psyomicsPrivacyPolicy), [some text to link](orgPrivacyPolicy])',
    },
    fields: {
      title: {
        type: 'text',
      },
    },
    render: createRootRenderer(),
  };
};
